import React from 'react'
import loader from "../../assets/loader.json";
import Lottie from "lottie-react"; 
import './loader.scss'

function Loader() {
  return (
    <div className='loaderMain'>
     <Lottie animationData={loader} loop={true} className='lottieMain'   />
    </div>
  )
}

export default Loader